import {useCallback} from 'react';
import {produce} from 'immer';
import set from 'lodash/set';
import type {DataValue} from 'schemaDefinition/types';
import {useAppDispatch, useAppStore} from 'store/hooks';
import {metadataEditManifestationEdited} from '../metadataEditSlice';
import {useMetadataSchemasCodelists} from './useMetadataSchemasCodelists';
import type {ManifestationV4} from '../types';

export const useSetManifestationEditValue = (entityId: string) => {
  const {getState} = useAppStore();
  const dispatch = useAppDispatch();
  const codelists = useMetadataSchemasCodelists();

  return useCallback(
    (localPath: string, value: DataValue) => {
      const manifestation = ((
        getState().metadataEdit.metadata?.manifestations ?? []
      ).find(e => e.id === entityId) ?? {}) as ManifestationV4;
      const newManifestation = produce(manifestation, draft => {
        set(draft, localPath, value);
      });

      dispatch(
        metadataEditManifestationEdited({
          manifestation: newManifestation,
          codelists,
        }),
      );
    },
    [codelists, dispatch, entityId, getState],
  );
};
